import React, { FC } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import { getRequestParams } from '../../tools/service';

interface Props extends RouteProps {
  component: any;
}

const PublicRoute: FC<Props> = ({ component: Component, ...rest }) => {
  let token = ""
  if (localStorage.getItem("token")) {
    token = getRequestParams() as any
  }
  return (
    <Route {...rest} render={props => !token ? <Component {...props} /> : <Redirect to="/admin" />} />
  );
}

export default PublicRoute;